import { FC, useState, useEffect } from 'react';

import useNavParams from './useNavParams';

export interface TabRoute {
  id: number;
  name: string;
  Component: FC;
}

export function useTabNavigation(pages: TabRoute[]) {
  const [tabIndex, setTabIndex] = useState(0);
  const { params } = useNavParams();

  useEffect(() => {
    if (params?.page) {
      const { page } = params;
      const idx = pages.findIndex(({ name }) => name === page);
      if (tabIndex === idx) return;

      setTabIndex(idx);
    }
  }, [params]);

  return [tabIndex, setTabIndex] as const;
}
